<h1 mat-dialog-title>New Email Template</h1>
<div mat-dialog-content>
    <div [formGroup]="emailTemplateForm">
        <div *ngIf="!this.data.hideName">
            <mat-form-field>
                <input aria-label="Name"
                       matInput
                       [(ngModel)]="data.name"
                       placeholder="Name"
                       formControlName="name"
                >
            </mat-form-field>
        </div>
        <div>
            <mat-form-field style="max-width: 600px;">
                <input aria-label="Subject"
                       formControlName="subject"
                       [(ngModel)]="data.subject"
                       matInput
                       placeholder="Subject" />
            </mat-form-field>
        </div>

        <!-- Template Type Selection -->
        <div class="template-type-selection" style="margin-bottom: 20px;">
            <h4>Select Template Type:</h4>
            <mat-radio-group
                formControlName="templateType"
                [(ngModel)]="selectedTemplateType"
                (change)="onTemplateTypeChange($event)">
                <mat-radio-button [value]="0" class="mr-3">
                    Custom (Free-form HTML Editor)
                </mat-radio-button>
                <mat-radio-button [value]="1">
                    TemplateA (Structured Layout)
                </mat-radio-button>
            </mat-radio-group>
            <p class="template-type-description" style="font-size: 12px; color: #666; margin-top: 8px;">
                <span *ngIf="selectedTemplateType === 0">
                    Use the rich text editor to create your email content from scratch.
                </span>
                <span *ngIf="selectedTemplateType === 1">
                    Use a pre-defined layout where you can customize images and text. Full customization available after creation.
                </span>
            </p>
        </div>

        <!-- Show editor based on template type -->
        <div *ngIf="selectedTemplateType === 0">
            <app-text-editor #typeEmail
                            formControlName="email"
                            id="rteEmail"
                            [(ngModel)]="data.emailContentHtml"
                            placeholder="Enter email body here..."
            ></app-text-editor>
        </div>

        <div *ngIf="selectedTemplateType === 1" style="padding: 20px; background-color: #f9f9f9; border-radius: 8px;">
            <p style="color: #666; margin: 0;">
                <mat-icon style="vertical-align: middle; margin-right: 8px;">info</mat-icon>
                TemplateA will be initialized with default structure. You can customize images and content after creation.
            </p>
        </div>
    </div>

</div>
<div mat-dialog-actions>
    <button [disabled]="!data.name || data.name.length == 0 || !data.subject || data.subject.length == 0 || (selectedTemplateType === 0 && (!data.emailContentHtml || data.emailContentHtml.length == 0))"
            [mat-dialog-close]="data"
            class="mr-1"
            color="accent"
            mat-flat-button>
        {{ submitButtonTitle }}
    </button>
    <button [mat-dialog-close]="" class="mr-1" mat-stroked-button>Cancel</button>
</div>
